import styled from 'styled-components';
import * as Colors from 'HubStyleTokens/colors';
import { rgba } from '../utils/rgba';
export const Overlay = styled.div.withConfig({
  displayName: "FullScreenSearchstyles__Overlay",
  componentId: "ul425z-0"
})(["position:fixed;z-index:2000;top:0;left:0;height:100%;width:100%;background-color:rgba(255,255,255,0.9);@media screen and (min-width:600px){display:flex;align-items:center;}"]);
export const Modal = styled.div.withConfig({
  displayName: "FullScreenSearchstyles__Modal",
  componentId: "ul425z-1"
})(["background-color:white;max-width:600px;width:100%;display:flex;overflow-y:auto;box-shadow:0 0 20px ", ";height:100%;@media screen and (min-height:766px) and (min-width:600px){height:90%;width:80%;}"], rgba(Colors.PANTERA, 0.2)); //Header styles

export const FixedElevatedHeader = styled.div.withConfig({
  displayName: "FullScreenSearchstyles__FixedElevatedHeader",
  componentId: "ul425z-2"
})(["z-index:2000;background-color:white;position:fixed;width:100%;max-width:600px;box-shadow:0 1px 5px 0 ", ";"], rgba(Colors.PANTERA, 0.12));
export const HeaderContainer = styled.div.withConfig({
  displayName: "FullScreenSearchstyles__HeaderContainer",
  componentId: "ul425z-3"
})(["max-width:700px;align-items:center;justify-content:stretch;display:flex;height:100%;"]); //Results

export const ResultsContainer = styled.div.withConfig({
  displayName: "FullScreenSearchstyles__ResultsContainer",
  componentId: "ul425z-4"
})(["font-size:1.25rem;padding-left:1.5rem;padding-right:1.5rem;margin-top:6.25rem;overflow:auto;width:100%;background:linear-gradient(white 30%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),white 70%) 0 100%,linear-gradient(", ",white),0 100%;background-repeat:no-repeat;background-color:white;background-size:100% 40px,100% 40px,100% 14px,100% 14px;background-attachment:local,local,scroll,scroll;"], rgba(Colors.PANTERA, 0.2));